import ProductService from '../../api/services/ProductService';

export const namespaced = true;

export const state = {
  groups: [],
  group: {},
  style: {},
  loading: false,
};

export const mutations = {
  SET_GROUPS(state, groups) {
    state.groups = groups;
  },
  SET_GROUP(state, group) {
    state.group = group;
  },
  SET_STYLE(state, style) {
    state.style = style;
  },
  CLEAR_STYLE(state) {
    state.style = {};
  },
  LOADING(state, loading) {
    state.loading = loading;
  },
};

export const actions = {
  fetchGroups({ commit, dispatch }, { cityId }) {
    commit('LOADING', true);
    ProductService.getGroupsWithStyles(cityId, 'COLLAR')
      .then((response) => {
        commit('SET_GROUPS', response);
        // if (!state.style && response?.[0]?.productStyles?.[0]) commit('SET_STYLE', response?.[0]?.productStyles?.[0]);
        commit('LOADING', false);
      })
      .catch((error) => {
        commit('SET_GROUPS', []);
        commit('LOADING', false);
        error.location = 'fetchGroups';
        dispatch(
          'notification/notifyFailure',
          { message: 'There was an error loading our pawesome products.', options: { dismissSecs: 15 } },
          { root: true }
        );
      });
  },
  fetchGroup({ commit }, { id, cityId }) {
    commit('LOADING', true);
    ProductService.getGroup(id, cityId)
      .then((response) => {
        commit('SET_GROUP', response);
        commit('LOADING', false);
      })
      .catch((error) => {
        commit('SET_GROUP', {});
        commit('LOADING', false);
        error.location = 'fetchGroup';
      });
  },
  removeGroup({ commit }) {
    commit('SET_GROUP', {});
  },
  clearStyle({ commit }) {
    commit('CLEAR_STYLE');
  },
  setStyle({ commit }, style) {
    if (!style) return;
    commit('SET_STYLE', style);
  },
  setStyleByCode({ commit, state }, { styleCode, groupId }) {
    if (!styleCode || !groupId) return;
    const productStyles = state.groups?.find((group) => group?.id === groupId)?.productStyles;
    const productStyle = productStyles?.find((style) => style?.code === styleCode);
    if (productStyle && productStyle?.code) {
      commit('SET_STYLE', productStyle);
    }
  },
};

export const getters = {};
